
import isClient from '@/mixins/isClient'
import ogPagesMixins from '@/mixins/ogPagesMixins'
export default {
  mixins: [ogPagesMixins, isClient],
  layout: 'clear',
  async asyncData({ $axios, route, $auth }) {
    try {
      const { product, author, isAvailable, isPast } = await $axios.$get(
        `/broadcast/${route.params.id}`
      )

      let existingLead = null
      if ($auth.loggedIn) {
        existingLead = await $axios.$get('/lead/product/have', {
          params: {
            entityType: product.type,
            entity: product._id,
            userId: $auth.user.id,
          },
        })
      }
      return {
        product,
        author,
        isAvailable,
        isPast,
        existingLead,
      }
    } catch (err) {
      // const statusCode = err.response?.data.statusCode
      // const message = err.response?.data.message
      // this.$error({
      //   statusCode,
      //   message,
      // })
    }
  },
  data() {
    return {
      product: null,
      author: null,
      info: null,
      isShowContacts: false,
      linkMessage: null,
      existingLead: null,
      isAvailable: true,
    }
  },
  computed: {
    authorType() {
      return this.author?.type === 'COMPANY' ? 'Компания' : 'Автор'
    },
    authorDescription() {
      if (this.author.type === 'COMPANY') {
        return this.author?.company?.description
      } else {
        return this.author?.profile?.description
      }
    },
    startDate() {
      if (this.product?.date?.startDate) {
        const date = this.$dayjs(this.product.date.startDate).format(
          'DD MMMM YYYY года в HH-mm'
        )
        return date
      } else {
        return null
      }
    },
    lead() {
      return {
        title: this.isPast ? 'Получить доступ ' : 'Записаться на премьеру',
        description: null,
        data: {
          title: this.product?.title,
          to: this.author?._id,
          type: 'REQUEST',
          level: 'PERSONAL',
          body: null,
          source: {
            position: `Кнопка Записаться на странице трансляции «${this.product?.title}»`,
            chapter: 'Страница трансляции',
            source: this.$route.path,
            entity: this.product._id,
            entityType: this.product.type,
          },
        },
      }
    },
    seoTitle() {
      return `${this.product?.title} | ${this.authorName} | Мегасреда`
    },
    seoDescription() {
      return this.preText
    },
    seoImage() {
      return {
        url: this.product?.ogImg
          ? `https://img.megasreda.ru/optimize?src=${this.product?.ogImg}&size=1200&format=jpeg`
          : `https://api.megasreda.ru/image/ogimage/broadcast/${this.product?._id}.jpg`,

        urlVk: this.product?.ogImgVk
          ? `https://img.megasreda.ru/optimize?src=${this.product?.ogImgVk}&size=1020&format=jpeg`
          : `https://api.megasreda.ru/image/ogimage/broadcast/vk/${this.product?._id}.jpg`,

        urlTw: this.product?.ogImg
          ? `https://img.megasreda.ru/optimize?src=${this.product?.ogImg}&size=1200&format=jpeg`
          : `https://api.megasreda.ru/image/ogimage/broadcast/${this.product?._id}.jpg`,

        type: 'image/jpeg',
        width: 1200,
        height: 630,
      }
    },
    authorName() {
      if (this.author?.type === 'COMPANY') {
        return this.author.company.title
          ? this.author?.company?.title
          : this.author?.username
      } else {
        return this.author?.profile?.firstName && this.author?.profile?.lastName
          ? `${this.author?.profile?.firstName} ${this.author?.profile?.lastName}`
          : this.author?.username
      }
    },
    authorContacts() {
      if (this.author?.type === 'COMPANY') {
        return this.author.company.contacts
      } else {
        return this.author.profile.contacts
      }
    },
    isAdmin() {
      return !!this.$auth?.user?.roles?.some((role) =>
        ['ADMIN', 'MODERATOR'].includes(role)
      )
    },
    preText() {
      if (this.product?.shortDescription) {
        return this.product.shortDescription
      } else if (this.product?.description) {
        const text = this.product.description
        if (text?.blocks?.length) {
          const preText = text?.blocks?.find(
            (block) => block.type === 'paragraph'
          )
          return preText?.data?.text
        }
      }
      return null
    },
    price() {
      switch (this.product?.price?.priceDisplay) {
        case 'FREE':
          return 'Бесплатно'
        case 'AGREEMENT':
          return 'По договорённости'
        case 'EXACT':
          return `${new Intl.NumberFormat('ru-Ru').format(
            this.product?.price?.exactPrice
          )}\u00A0₽`
        case 'RANGE':
          return this.product?.price?.rangeEndPrice
            ? `от ${new Intl.NumberFormat('ru-Ru').format(
                this.product?.price?.rangeStartPrice
              )}\u00A0₽ до ${new Intl.NumberFormat('ru-Ru').format(
                this.product?.price?.rangeEndPrice
              )}\u00A0₽`
            : `от ${new Intl.NumberFormat('ru-Ru').format(
                this.product?.price?.rangeStartPrice
              )}\u00A0₽`
        default:
          return null
      }
    },
    oldPrice() {
      return this.product?.price?.oldPrice
    },
    provisionType() {
      return this.product?.provisionType === 'ONLINE' ? 'Онлайн' : 'Офлайн'
    },
    cover() {
      if (this.product?.cover) {
        return this.product?.cover
      } else if (this.author?.type === 'COMPANY') {
        return this.author?.company?.cover ? this.author.company.cover : null
      } else {
        return this.author?.profile?.cover ? this.author.profile.cover : null
      }
    },
    ratings() {
      if (this.author?.type === 'COMPANY') {
        return this.author?.company?.ratings
      } else {
        return this.author?.profile?.ratings
      }
    },
    certificates() {
      if (this.author?.type === 'COMPANY') {
        return this.author?.company?.certificates
      } else {
        return this.author?.profile?.certificates
      }
    },
    customers() {
      if (this.author?.type === 'COMPANY') {
        return this.author?.company?.customers
      } else {
        return this.author?.profile?.customers
      }
    },
  },

  created() {
    if (process?.client) {
      this.$eventBus.$on('updateSubscriptions', async () => {
        await this.fetchProduct()
      })
    }
  },
  beforeDestroy() {
    this.$eventBus.$off('updateSubscriptions')
  },

  mounted() {
    this.setView()
  },
  methods: {
    async fetchProduct() {
      try {
        const { product, author, isAvailable, isPast } = await this.$axios.$get(
          `/broadcast/${this.$route.params.id}`
        )
        this.product = product
        this.author = author
        this.isAvailable = isAvailable
        this.isPast = isPast
      } catch (err) {
        // const statusCode = err.response?.data.statusCode
        // const message = err.response?.data.message
        // this.$error({
        //   statusCode,
        //   message,
        // })
      }
    },
    async fetchExistingLead() {
      const existingLead = await this.$axios.$get('/lead/product/have', {
        params: {
          entityType: this.product.type,
          entity: this.product._id,
          userId: this.$auth.user.id,
        },
      })
      this.existingLead = existingLead
      await this.fetchProduct()
    },
    setView() {
      setTimeout(() => {
        if (this.product && this.author) {
          this.$axios.$post('/activity/view/advertisement', {
            username: this.author.username,
            advertisementId: this.product._id,
          })
        }
      }, 2500)
    },
    async setShowContactsCount() {
      await this.$axios.$post('/activity/show/advertisement/contacts', {
        username: this.author?.username,
        advertisementId: this.product._id,
      })
    },
    async setTransitionCount() {
      await this.$axios.$post('/activity/set/advertisement/transition', {
        username: this.author?.username,
        advertisementId: this.product._id,
      })
    },
    async getInfo() {
      this.info = await this.$axios.$get(
        `/advertisement/info/${this.$route.params.id}`
      )
    },
    async showContacts() {
      if (this.$auth.loggedIn) {
        await this.getInfo()
        await this.setShowContactsCount()
        this.$refs.showContacts.open()
      } else {
        this.$router.push('/login')
      }
    },
    async goOrder() {
      if (this.$auth.loggedIn) {
        await this.getInfo()
        if (this.info?.link) {
          const a = document.createElement('a')
          document.body.appendChild(a)
          a.style = 'display: none'
          a.href = this.info.link
          a.target = '_blank'
          a.click()
          document.body.removeChild(a)
          await this.setTransitionCount()
        } else {
          this.linkMessage =
            '😔 К сожалению автор не указал ссылку на сайт заказа. Используйте контакты для связи.'
          this.$refs.showLinkMessage.open()
        }
      } else {
        this.$router.push('/login')
      }
    },
  },
}
